import getFetchClient from '@/fetchers/getFetchClientBrowser';
import type { Logger } from '@cvent/logging/types';

const APP_NAME = 'searchApp';
const EMPTY_STUB = '00000000-0000-0000-0000-000000000000';

type Ad = {
  supplierId: string;
  adCode: string | undefined | null;
  competitiveSetFlag: boolean;
  competitiveSetOfferingStub?: string;
  needDatesFlag: boolean;
};

export default async function reportToCventAdTrack(
  csnSearchAppServiceBaseUrl: string,
  adData: Ad[],
  adSessionId: string,
  rfpId: string | undefined,
  action: 'AD_VIEWED' | 'AD_CLICKED',
  logger: Logger,
  environment: string
): Promise<void> {
  const data = {
    sessionId: adSessionId,
    actionType: action,
    suggestedAdsList: adData,
    rfpId: rfpId ?? EMPTY_STUB,
    calledBy: APP_NAME
  };

  const fetchClient = getFetchClient();
  try {
    const response = await fetchClient.post(
      `${csnSearchAppServiceBaseUrl}cvads/track?env=${environment}`,
      JSON.stringify(data),
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    if (response?.status !== 204) {
      throw Error('Failed to track diamond plus/ suggested ads');
    }
  } catch (error) {
    // log error and continue
    logger.error(`Failed to track diamond plus/ suggested ads. Data - ${JSON.stringify(data)}. Got %o`, error);
  }
}
